<template>
  <div class="redisMonitorSearch">
    <Row :gutter="4">
      <!-- 选择公司 -->
      <div v-if="company == 1">
        <Col span="4">
          <Select
            v-model="companyId"
            filterable
            :placeholder="$t('alarms.common.pleaseSelectCompany')"
            :transfer="true"
          >
            <Option value=" " selected>{{ $t("alarms.common.all") }}</Option>
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
        <Col span="4">
          <Select
            v-model="accountType"
            filterable
            :placeholder="$t('alarms.common.filterByAccountType')"
            :transfer="true"
          >
            <Option value="" selected>{{ $t("alarms.common.all") }}</Option>
            <Option
              :value="item.id"
              v-for="item in accountTypeList"
              :key="item.name"
              >{{ item.name }}</Option
            >
          </Select></Col
        >
      </div>
      <Col span="3">
        <!-- v-on:input实时查询 -->
        <Input
          v-model="accountName"
          :placeholder="$t('alarms.common.filterByAccountName')"
        />
      </Col>
      <Col span="3">
        <!-- v-on:input实时查询 -->
        <Input
          v-model="dbClusterIdentifier"
          :placeholder="$t('DocDBMonitor.ClusterIdentifier')"
        />
      </Col>
      <Col span="3">
        <Button
          type="primary"
          v-hasPermission="['monitor:DocDBMonitor:page']"
          @click="getData"
          >{{ $t("message.select") }}</Button
        >
      </Col>
    </Row>
  </div>
</template>
<script>
import TableRedis from "./TableRedis";
import { setCookie, getCookie } from "@/utils/cookieUtil.js";
var tableRedis = TableRedis;
export default {
  name: "RedisMonitorSearch",
  data() {
    return {
      company: getCookie(global.companyId),
      companyId: "",
      companyList: [],
      cacheClusterId: "",
      accountType: "",
      accountName: "",
      dbClusterIdentifier: "",
      accountTypeList: [
        {
          id: 0,
          name: "AWS"
        },
        {
          id: 1,
          name: "Aliyun"
        },
        {
          id: 2,
          name: "Azure"
        },
        {
          id: 3,
          name: "VMware"
        },
        {
          id: 4,
          name: "GCP"
        }
      ]
    };
  },
  mounted: function() {
    if (this.company == 1) {
      this.getCompanyDropDownBox();
    }
  },
  methods: {
    getData() {
      eventBus.$emit("companyId", this.companyId);
      eventBus.$emit("accountType", this.accountType);
      eventBus.$emit("accountName", this.accountName);
      eventBus.$emit("dbClusterIdentifier", this.dbClusterIdentifier);
      tableRedis.methods.showAll();
    },
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
        });
    }
  }
};
</script>
<style scoped>
.redisMonitorSearch {
  height: 51px;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/DocDBMonitor/RedisMonitorSearch.vue